import { takeEvery, put, call } from "redux-saga/effects";
import { ActionTypes } from "../constants";
import { request } from "src/helpers/request";

// FETCH NOTIFICATIONS (REST API)


function* fetchNotifications() {
    try {

        const response = yield call(request, 'get', `/notifications`)
        const json = yield response.data;

        yield put({
            type: ActionTypes.NOTIF_FETCH_SUCCESS,
            payload: json,
        });
    } catch (error) {
        console.log('error', error)

        yield put({
            type: ActionTypes.NOTIF_FETCH_FAILED,
            payload: error,
        });
    }
}

function* ReadNotif(payload) {
    try {
        // console.log(payload)
        const response = yield call(request, 'post', `/notifications`, { id: payload?.id, action: "read" })
        const json = yield response.data;

        yield put({
            type: ActionTypes.NOTIF_FETCH_SUCCESS,
            payload: json,
        });
    } catch (error) {
        console.log('error', error)

        yield put({
            type: ActionTypes.NOTIF_FETCH_FAILED,
            payload: error,
        });
    }
}

function* ReadAllNotif(payload) {
    try {
        // console.log(payload)
        const response = yield call(request, 'post', `/notifications`, { action: "read_all" })
        const json = yield response.data;

        yield put({
            type: ActionTypes.NOTIF_FETCH_SUCCESS,
            payload: json,
        });
    } catch (error) {
        console.log('error', error)

        yield put({
            type: ActionTypes.NOTIF_FETCH_FAILED,
            payload: error,
        });
    }
}

function* postUnRead(payload) {
    try {
        // console.log(payload)
        const response = yield call(request, 'post', `/notifications`, { action: "unread", id: payload?.id })
        const json = yield response.data;

        yield put({
            type: ActionTypes.NOTIF_FETCH_SUCCESS,
            payload: json,
        });
    } catch (error) {
        console.log('error', error)

        yield put({
            type: ActionTypes.NOTIF_FETCH_FAILED,
            payload: error,
        });
    }
}
function* postImportant(payload) {
    try {
        // console.log(payload)
        const response = yield call(request, 'post', `/notifications`, { action: "important", id: payload?.id })
        const json = yield response.data;

        yield put({
            type: ActionTypes.NOTIF_FETCH_SUCCESS,
            payload: json,
        });
    } catch (error) {
        console.log('error', error)

        yield put({
            type: ActionTypes.NOTIF_FETCH_FAILED,
            payload: error,
        });
    }
}

// NO MORE websocket worker here
// websocket berasal dari SocketProvider, bukan saga
export function* watchFetchNotifications() {
    yield takeEvery(ActionTypes.NOTIF_FETCH, fetchNotifications);
    yield takeEvery(ActionTypes.NOTIF_MARK_READ, ReadNotif);
    yield takeEvery(ActionTypes.NOTIF_MARK_READ_ALL, ReadAllNotif);
    yield takeEvery(ActionTypes.NOTIF_MARK_UNREAD, postUnRead);
    yield takeEvery(ActionTypes.NOTIF_TOGGLE_IMPORTANT, postImportant);
}

// export default function* root() {
//     yield all([
//         takeEvery(ActionTypes.NOTIF_FETCH, (fetchNotifications))
//     ])
//     //
// }


// export default function* watchVerify2FA() {
//     yield takeLatest(ActionTypes.VERIFY_2FA, verify2FAWorker);
// }
